const matrixRowPrefix = 'question-form-matrix-row';

const generateMatrixRowFormName = (blockUuid, rowUuid) =>
  `${matrixRowPrefix}-${blockUuid}-${rowUuid}`;

export default generateMatrixRowFormName;
